// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import baseDark from '../../img/dark-theme/base.png'
import networkDark from '../../img/dark-theme/network.png'
import bateriasFueraDark from '../../img/dark-theme/batteries-outside.png'
import casaDark from '../../img/dark-theme/house.png'
import bateriasDentroDark from '../../img/dark-theme/batteries-inside.png'
import grupoDark from '../../img/dark-theme/generator.png'
import dispositivosDark from '../../img/dark-theme/smart-devices.png'
import cargadorCocheDark from '../../img/dark-theme/car-charger.png'
import cocheDark from '../../img/dark-theme/car.png'
import panelesSolaresDark from '../../img/dark-theme/solar-panels.png'

// Función del router
const WorkflowIlustration = (params) => {
  
  useEffect(() => {    
    
    console.log("Actualizo ilustracion")

    var elementosInstalacion = params.illustrationElements

    if(elementosInstalacion !== undefined){

      // GeneralInfo != ""
      if(elementosInstalacion.includes("HOUSE")){ document.getElementById("capaCasa").className = "house layer" }
      else{ document.getElementById("capaCasa").className = "house layer invisible" }

      // GeneralInfo.EnergyGridConnected = "true"
      if(elementosInstalacion.includes("GRID_CONNECTED")){ document.getElementById("capaNetwork").className = "network layer" }
      else{ document.getElementById("capaNetwork").className = "network layer invisible" }

      // FV != ""
      if(elementosInstalacion.includes("FV")){ document.getElementById("capaPaneles").className = "solar-panels layer" }
      else{ document.getElementById("capaPaneles").className = "solar-panels layer invisible" }

      // Battery.BatteriesLocationConstantTemperature != ""
      if(elementosInstalacion.includes("BATTERY_IN")){ document.getElementById("capaBateriasDentro").className = "batteries-inside layer"; }
      else{ document.getElementById("capaBateriasDentro").className = "batteries-inside layer invisible" }

      // Battery.BatteriesLocationConstantTemperature = ""
      if(elementosInstalacion.includes("BATTERY_OUT")){ document.getElementById("capaBateriasFuera").className = "batteries-outside layer" }
      else{ document.getElementById("capaBateriasFuera").className = "batteries-outside layer invisible" }

      // Generator != ""
      if(elementosInstalacion.includes("GENERATOR")){ document.getElementById("capaGrupo").className = "generator layer" }
      else{ document.getElementById("capaGrupo").className = "generator layer invisible" }

      // Cars != ""
      if(elementosInstalacion.includes("CARS")){ document.getElementById("capaCoche").className = "car layer" }
      else{ document.getElementById("capaCoche").className = "car layer invisible" }

      // Cars.ChargesInCurrentInstallation = "true"
      if(elementosInstalacion.includes("CAR_CHARGER")){ document.getElementById("capaCargadorCoche").className = "car-charger layer" }
      else{ document.getElementById("capaCargadorCoche").className = "car-charger layer invisible" }

      // customizedWorkflow includes DEVICES
      if(elementosInstalacion.includes("DEVICES")){ document.getElementById("capaDispositivos").className = "smart-devices layer" }
      else{ document.getElementById("capaDispositivos").className = "smart-devices layer invisible" }    
    }
    
  });

  return (    
    <picture id="workflowIllustration" className="main-illustration">
      <picture className="base layer">
        <source srcSet={baseDark} media="(prefers-color-scheme: dark)"/>
        <img src={baseDark} alt="base"/>
      </picture>
      <picture id="capaNetwork" className="network layer invisible">
        <source srcSet={networkDark} media="(prefers-color-scheme: dark)"/>
        <img src={networkDark} alt="network"/>
      </picture>
      <picture id="capaBateriasFuera" className="batteries-outside layer invisible">
        <source srcSet={bateriasFueraDark} media="(prefers-color-scheme: dark)"/>
        <img src={bateriasFueraDark} alt="batteries-outside"/>
      </picture>
      <picture id="capaCasa" className="house layer invisible">
        <source srcSet={casaDark} media="(prefers-color-scheme: dark)"/>
        <img src={casaDark} alt="house"/>
      </picture>
      <picture id="capaBateriasDentro" className="batteries-inside layer invisible">
        <source srcSet={bateriasDentroDark} media="(prefers-color-scheme: dark)"/>
        <img src={bateriasDentroDark} alt="batteries-inside"/>
      </picture>
      <picture id="capaGrupo" className="generator layer invisible">
        <source srcSet={grupoDark} media="(prefers-color-scheme: dark)"/>
        <img src={grupoDark} alt="generator"/>
      </picture>
      <picture id="capaDispositivos" className="smart-devices layer invisible">
        <source srcSet={dispositivosDark} media="(prefers-color-scheme: dark)"/>
        <img src={dispositivosDark} alt="smart-devices"/>
      </picture>
      <picture id="capaCargadorCoche" className="car-charger layer invisible">
        <source srcSet={cargadorCocheDark} media="(prefers-color-scheme: dark)"/>
        <img src={cargadorCocheDark} alt="car-charger"/>
      </picture>
      <picture id="capaCoche" className="car layer invisible">
        <source srcSet={cocheDark} media="(prefers-color-scheme: dark)"/>
        <img src={cocheDark} alt="car"/>
      </picture>
      <picture id="capaPaneles" className="solar-panels layer invisible">
        <source srcSet={panelesSolaresDark} media="(prefers-color-scheme: dark)"/>
        <img src={panelesSolaresDark} alt="solar-panels"/>
      </picture>
    </picture>
  )
}

export default WorkflowIlustration